import type { DialogProps } from './Dialog.types'
import cn from 'classnames'
import React from 'react'
import { IndeterminateProgressCircle } from '../IndeterminateProgressCircle'
import { Icon } from './../icon'
import { Typography } from './../typography'
import styles from './Dialog.module.css'

export function Dialog({ icon, text, supportingText, type, actionsSlot, className, children }: DialogProps) {
  const isAlert = type === 'alert'
  const glyph = isAlert ? 'ExclamationInTriangle' : icon

  return (
    <div
      role={isAlert ? 'alert' : undefined}
      aria-live={isAlert ? 'assertive' : undefined}
      className={cn(styles.dialog, className)}
    >
      {glyph && (
        (glyph === 'Spinner')
          ? (
              <IndeterminateProgressCircle />
            )
          : (
              <Icon
                glyph={glyph}
                aria-hidden="true"
                className={cn(styles.icon, { [styles.iconAlert]: isAlert })}
              />
            )
      )}
      <Typography as="div" className={styles.title} variant="body-m-bold-snug">
        {text}
      </Typography>
      {supportingText && (
        <Typography as="div" className={styles.subtitle} variant="body-s-regular-snug">
          {supportingText}
        </Typography>
      )}
      {children}
      {actionsSlot}
    </div>
  )
}
